import React, { useState } from 'react';
import styles from '../pages/UserDetailsPage.module.css';
import api from '../utils/api';

const Portfolio = ({ user, userId, onSaveSuccess }) => {
    const [isEditingPortfolio, setIsEditingPortfolio] = useState(false);
    const [editedPortfolioData, setEditedPortfolioData] = useState({
        totalPortfolio: user.totalPortfolio,
        stockHoldings: user.stockHoldings || [],
        mutualfundsHoldings: user.mutualfundsHoldings || []
    });

    const handlePortfolioChange = (e, index, type) => {
        const { name, value } = e.target;
        const updatedHoldings = [...editedPortfolioData[type]];
        updatedHoldings[index][name] = value;
        setEditedPortfolioData(prev => ({ ...prev, [type]: updatedHoldings }));
    };

    const handleTotalPortfolioChange = (e) => {
        const { name, value } = e.target;
        setEditedPortfolioData(prev => ({ ...prev, totalPortfolio: { ...prev.totalPortfolio, [name]: value } }));
    };

    const handleAddHolding = (type) => {
        setEditedPortfolioData(prev => ({ ...prev, [type]: [...prev[type], { symbol: '', value: 0, investment: 0, change: 0 }] }));
    };

    const handleRemoveHolding = (index, type) => {
        const updatedHoldings = [...editedPortfolioData[type]];
        updatedHoldings.splice(index, 1);
        setEditedPortfolioData(prev => ({ ...prev, [type]: updatedHoldings }));
    };

    const handleSavePortfolio = async () => {
        try {
            await api.put(`/api/admin/users/${userId}/portfolio`, editedPortfolioData);
            setIsEditingPortfolio(false);
            alert('Portfolio updated successfully!');
            if (onSaveSuccess) {
                onSaveSuccess();
            }
        } catch (err) {
            console.error('[Admin Frontend] Failed to update portfolio', err);
            alert('Failed to update portfolio');
        }
    };

    return (
        <>
            {isEditingPortfolio ? (
                <div className={styles['edit-portfolio-form']}>
                    <div className={styles['form-group']}>
                        <label>Current Value:</label>
                        <input type="number" name="value" value={editedPortfolioData.totalPortfolio.value} onChange={handleTotalPortfolioChange} />
                    </div>
                    <div className={styles['form-group']}>
                        <label>Total Investment:</label>
                        <input type="number" name="investment" value={editedPortfolioData.totalPortfolio.investment} onChange={handleTotalPortfolioChange} />
                    </div>
                    <div className={styles['form-group']}>
                        <label>Portfolio Change:</label>
                        <input type="number" name="change" value={editedPortfolioData.totalPortfolio.change} onChange={handleTotalPortfolioChange} />
                    </div>

                    <h3 className={styles['holding-section-header']}>
                        <span>Stock Holdings</span>
                        <button onClick={() => handleAddHolding('stockHoldings')} className={styles['add-holding-button']}>+ Add</button>
                    </h3>
                    <div className={styles['holdings-grid']}>
                        {editedPortfolioData.stockHoldings.map((holding, index) => (
                            <div key={index} className={styles['holding-card']}>
                                <div className={styles['holding-card-header']}>
                                    <span>Holding {index + 1}</span>
                                    <button onClick={() => handleRemoveHolding(index, 'stockHoldings')} className={styles['remove-holding-button']}>X Remove</button>
                                </div>
                                <div className={styles['holding-card-content']}>
                                    <input type="text" name="symbol" value={holding.symbol} onChange={(e) => handlePortfolioChange(e, index, 'stockHoldings')} placeholder="Symbol" />
                                    <input type="number" name="value" value={holding.value} onChange={(e) => handlePortfolioChange(e, index, 'stockHoldings')} placeholder="Value" />
                                    <input type="number" name="investment" value={holding.investment} onChange={(e) => handlePortfolioChange(e, index, 'stockHoldings')} placeholder="Investment" />
                                    <input type="number" name="change" value={holding.change} onChange={(e) => handlePortfolioChange(e, index, 'stockHoldings')} placeholder="Change" />
                                </div>
                            </div>
                        ))}
                    </div>

                    <h3 className={styles['holding-section-header']}>
                        <span>Mutual Funds Holdings</span>
                        <button onClick={() => handleAddHolding('mutualfundsHoldings')} className={styles['add-holding-button']}>+ Add</button>
                    </h3>
                    <div className={styles['holdings-grid']}>
                        {editedPortfolioData.mutualfundsHoldings.map((holding, index) => (
                            <div key={index} className={styles['holding-card']}>
                                <div className={styles['holding-card-header']}>
                                    <span>Holding {index + 1}</span>
                                    <button onClick={() => handleRemoveHolding(index, 'mutualfundsHoldings')} className={styles['remove-holding-button']}>X Remove</button>
                                </div>
                                <div className={styles['holding-card-content']}>
                                    <input type="text" name="symbol" value={holding.symbol} onChange={(e) => handlePortfolioChange(e, index, 'mutualfundsHoldings')} placeholder="Symbol" />
                                    <input type="number" name="value" value={holding.value} onChange={(e) => handlePortfolioChange(e, index, 'mutualfundsHoldings')} placeholder="Value" />
                                    <input type="number" name="investment" value={holding.investment} onChange={(e) => handlePortfolioChange(e, index, 'mutualfundsHoldings')} placeholder="Investment" />
                                    <input type="number" name="change" value={holding.change} onChange={(e) => handlePortfolioChange(e, index, 'mutualfundsHoldings')} placeholder="Change" />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className={styles['portfolio-actions']}>
                        <button onClick={handleSavePortfolio} className={styles['btn-approve']}>Save Portfolio</button>
                        <button onClick={() => setIsEditingPortfolio(false)} className={styles['delete-button']}>Cancel</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className={styles['info-group']}>
                        <span className={styles['info-label']}>Current Value:</span>
                        <span>{user.totalPortfolio.value}</span>
                    </div>
                    <div className={styles['info-group']}>
                        <span className={styles['info-label']}>Total Investment:</span>
                        <span>{user.totalPortfolio.investment}</span>
                    </div>
                    <div className={styles['info-group']}>
                        <span className={styles['info-label']}>Portfolio Change:</span>
                        <span>{user.totalPortfolio.change}</span>
                    </div>
                    <div className={styles['portfolio-actions']}>
                        <button className={styles['btn-approve']} onClick={() => setIsEditingPortfolio(true)}>Edit Portfolio</button>
                    </div>
                </>
            )}
        </>
    );
};

export default Portfolio;
